"use strict";var e=require("@apollo/client").gql`
  mutation registerCustomerOnlinePaymentMethod(
    $paymentMethodData: PaymentMethodDataType!
  ) {
    registerCustomerOnlinePaymentMethod(paymentMethodData: $paymentMethodData) {
      creditCards {
        cardExternalId
        cardMask
        cardBrand
      }
    }
  }
`;exports.r=e;